export const chartObj =
    [
        { title: "Fluid Quality", field: ["Acidity", "Water Content", "Breakdown Voltage"] },
        { title: "Gas Quality", field: ["Hydrocarbon Gases:", "Ethylene", "Ethane", "Acetylene", "Hydrogen", "Methane", "Oxides:", "Carbon Monoxide", "Carbon Dioxide"] },
        { title: "Insulating Paper Quality", field: ["Furanic Compounds", "Estimated DP"] },
        { title: "Environmental Assessment", field: ["PCB"] }
    ]
export const testParameters =
        {
            'Water Content': false, 'Breakdown Voltage': false, 'Acidity': false,
            'Ethylene': false, 'Ethane': false, 'Acetylene': false,
            'Methane': false, 'Carbon Monoxide': false, 'Carbon Dioxide': false,
            'Furanic Compounds': false, 'Estimated DP': false, 'PCB': false, 'Hydrogen': false,
        };
export const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]